





































































import { Vue, Component, Prop } from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";
import { isMobileApp } from "@/shared/mobileHelper";
import { print, fileHelper, share } from "@/shared/nativePlugins";

@Component({
  components: {
    Button
  }
})
export default class FormDownload extends Vue {
  isDownloading = false;
  isPrinting = false;
  isSharing = false;
  formDownloaded = false;

  @Prop({ required: true })
  generateForm: () => Promise<any>;

  @Prop({ required: true })
  goToNextStep: () => void;

  @Prop({ required: true })
  goToPreviousStep: () => void;

  get downloadDisabled () {
    return this.isDownloading;
  }

  get printDisabled () {
    return this.isPrinting;
  }

  get shareDisabled () {
    return this.isSharing;
  }

  get nextDisabled () {
    return this.$validator.errors.any();
  }

  get showShareOptions () {
    return isMobileApp();
  }

  downloadForm () {
    this.isDownloading = true;
    this.formDownloaded = true;
    this.$validator.errors.clear();
    this.generateForm()
      .then(result => {
        this.handleDownload(result.downloadUrl);
        this.isDownloading = false;
      })
      .catch(() => {
        this.isDownloading = false;
      });
  }

 async handleDownload (url: string) {
    if (isMobileApp()) {
      await share.shareUrlForDownload(url);
    } else {
      this.downloadFromUrl(url);
    }
  }

  downloadFromUrl (url: string) {
    const a = document.createElement("a");
    a.href = url;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  printForm () {
    const printWindow = this.openPrintWindow();
    this.isPrinting = true;
    this.formDownloaded = true;
    this.$validator.errors.clear();
    this.generateForm()
      .then(result => {
        this.handlePrint(result.url, printWindow);
        this.isPrinting = false;
      })
      .catch(() => {
        this.isPrinting = false;
      });
  }

  async handlePrint (url: string, printWindow: Window) {
    if (isMobileApp()) {
      await print.printPdf({ url, name: "Balance transfer form" });
    } else if (printWindow) {
      printWindow.location.href = url;
    } else {
      window.alert("Unable to print. Please allow pop-ups and try again.");
    }
  }

  openPrintWindow () {
    if (isMobileApp()) {
      return null;
    }

    return window.open("", "_blank");
  }

  async shareForm () {
    this.isSharing = true;
    this.formDownloaded = true;
    this.$validator.errors.clear();
    this.generateForm()
    .then(result => {
      return share.shareUrl(result.url)
      .then(() => {
        this.isSharing = false;
      });
    }).catch(_ => {
      this.isSharing = false;
    });
  }

  onNext () {
    let message = "Please download or print the form before continuing.";
    if (this.showShareOptions) {
      message = "Please download, print or share the form before continuing.";
    }
    if (!this.formDownloaded) {
      this.$validator.errors.add({
        field: "formDownloaded",
        msg: message
      });

      return;
    }

    this.goToNextStep();
  }
}
